import { useCallback } from 'react';
import { useEditor } from '../../state/editor';
import { useLibrary } from '../../state/library';
import { useUi } from '../../state/ui';
import { defaultSettings } from '../../model/defaults';
import type { Settings } from '../../model/types';

const FALLBACK = defaultSettings();

/** The active photo, its settings and an updater wired to undo (one step per drag) and the drag flag. */
export function useActive() {
  const id = useLibrary((s) => s.activeId);
  const photo = useLibrary((s) => s.photos.find((p) => p.id === s.activeId) ?? null);
  const settings = useEditor((s) => (id ? s.settings[id] : undefined)) ?? FALLBACK;
  const update = useCallback(
    (fn: (s: Settings) => void, final = true) => {
      if (!id) return;
      useEditor.getState().update(id, fn, { commit: final });
      useUi.getState().set({ dragging: !final });
    },
    [id],
  );
  return { id, photo, settings, update };
}
